import './toolbar.sass'

import React from 'react';
import { Translate } from 'react-redux-i18n';

import TrackListViewSwitch from 'controls/track-list-view-switch/TrackListViewSwitch';
import MenuDropdown from 'components/tracks-tree/menu-dropdown/MenuDropdown';
import CreateFolder from 'components/tracks-tree/create-folder/CreateFolder';

import NavbarToggle from 'controls/navbar-toggle/NavbarToggle';

export default function Toolbar (props) {
  return (
    <nav className='tracks-tree-toolbar navbar navbar-default'>
      <div className='container-fluid'>
        <div className='navbar-header'>
          <NavbarToggle/>
          <a className='navbar-brand' href='#'><Translate value='tracksTree.toolbar.trackList' /></a>
        </div>

        <div className='collapse navbar-collapse' id='bs-navbar-collapse'>
          <TrackListViewSwitch viewType={ props.viewType } />
          <MenuDropdown/>
          <CreateFolder/>
        </div>
      </div>
    </nav>
  );
}
